<template>
  <div class="dialog-wap">
    <el-dialog
      :model-value="visible"
      align-center
      width="480"
      :before-close="handleClose"
      class="error-dialog"
    >
      <template #header>
        <div class="my-header">
          <h4 class="px-2 pb-3 text-lg text-[#262626] font-semibold">
            合同类型
          </h4>
        </div>
      </template>
      <el-form
        ref="formRef"
        class="add-platform-users-form"
        require-asterisk-position="right"
        label-position="top"
        :model="form"
        :rules="formRules"
      >
        <el-form-item prop="remark" label="请选择合同类型">
          <el-select
            v-model="form.contractType"
            placeholder="模版类型"
            clearable
          >
            <el-option :label="contractTypeConfig[EContractType.FREE_CONTRACT]" :value="EContractType.FREE_CONTRACT" />
            <el-option :label="contractTypeConfig[EContractType.OFFLINE_CONTRACT]" :value="EContractType.OFFLINE_CONTRACT" />
          </el-select>
        </el-form-item>
      </el-form>
      <template #footer>
        <span class="dialog-footer">
          <el-button
            :loading="saveBtnLoading" @click="handleClose"
          >
            取消
          </el-button>
          <el-button type="primary" :loading="saveBtnLoading" @click="handleSubmit">
            确定
          </el-button>
        </span>
      </template>
    </el-dialog>
  </div>
</template>

<script setup lang="ts">

import { PropType, ref, watch } from 'vue';
import { ElMessage } from 'element-plus';
import {} from '../../../../..';
import { IContractCreatePage, contractTypeConfig, EContractType } from '../../../../../types/contracts/contracts';
import { useRouter } from 'vue-router';

const props = defineProps({
  visible: {
    type: Boolean,
    default: false,
  },
  row: {
    type: Object as PropType<IContractCreatePage>,
    default: () => {},
  },
});

const emit = defineEmits<{close: []}>();
const router = useRouter();

const saveBtnLoading = ref(false);
const formRef = ref();

const form = ref({ contractType: null });

const formRules = ref({
  contractType: [
    {
      message: '请选择合同类型',
      required: true,
    },
  ],
});

function handleClose() {
  formRef.value.resetFields();
  emit('close');
}

function handleSubmit() {

  formRef.value.validate((valid) => {
    if (valid) doSubmit();
  });
}

async function doSubmit() {

  saveBtnLoading.value = true;

  try {
    router.push({
      name: 'InitiateContract',
      query: {
        from: 'all',
        contractType: form.value.contractType,
      },
    });
  } catch (error) {
    if ((error as Error).message) ElMessage.error((error as Error).message);
  }
  saveBtnLoading.value = false;

}

async function fetchData() {
  try {

  } catch (error) {
    if ((error as Error).message) ElMessage.error((error as Error).message);
  }
}

async function init() {
  await fetchData();
  form.value = { contractType: null };
}
init();

watch(
  [
    () => props.visible,
    () => props.row,
  ],
  () => {
    // if (props.visible && props.data) {
    //   onMergeLines(props.data);
    // }
  },
  { immediate: true },
);
</script>

<style lang="scss" scoped>
.dialog-wap {
  :deep(.el-dialog__body) {
    padding-bottom: 6px;
    padding-left: 8px;
    padding-right: 8px;
  }
}
</style>
